import {useMutation} from '@tanstack/react-query'
import {sendBroadcastMessage} from '../services/chat.http'
import {MUTATION_KEYS} from './keys'
import {SendBroadcastMessageSchema} from '../chat.model'

import {useMe} from '@/features/authentication/queries/useMe'
import {LocalStorageManager} from '@/utilities/localStorage'
import {UserRoleE} from '@/types'

export const useSendBroadcastMessageV3 = () => {
    const {data: user} = useMe()
    const isRepresentative = user?.type === UserRoleE.Representative
    const representedCreatorId = isRepresentative ? LocalStorageManager.chatUserId.get() : undefined

    return useMutation({
        mutationKey: [MUTATION_KEYS.sendBroadcastMessage],
        mutationFn: ({broadcastGroupId, payload}: {broadcastGroupId: string; payload: SendBroadcastMessageSchema}) =>
            sendBroadcastMessage(broadcastGroupId, payload, representedCreatorId ? {representedCreatorId} : undefined)
    })
}
